/**
 * Utilities for working with scene layouts, for example in a UGC scene with a fullscreen layout.
 *
 * Layout Meanings:
 * a: Standard theme
 * b: Standard theme with dramatic style
 * c: Fullscreen with titles
 * d: Fullscreen without titles
 * e: Fullscreen dramatic with titles
 * f: Fullscreen dramatic without titles
 * g: Lower third
 * h: Vertical
 */
export class LayoutService {
  /**
   * Returns true if the layout specified by layoutName is a fullscreen layout; otherwise, false.
   */
  isFullscreen (layoutName) {
    return LayoutService.fullscreenLayouts.includes(layoutName);
  }

  /**
   * Returns true if the layout specified by layoutName includes titles such as name, city, and
   * comment; otherwise, false.
   */
  hasTitles (layoutName) {
    return LayoutService.layoutsWithTitles.includes(layoutName);
  }

  /**
   * Returns true if the layout specified by layoutName is considered a "dramatic" layout (i.e.,
   * with a background "ken burns" animation effect).
   */
  isDramatic (layoutName) {
    return LayoutService.dramaticLayouts.includes(layoutName);
  }
}

LayoutService.dramaticLayouts = ['b', 'e', 'f'];
LayoutService.fullscreenLayouts = ['c', 'd', 'e', 'f'];
LayoutService.layoutsWithTitles = ['c', 'e'];
